import Marquee from "react-fast-marquee";

const items = ["Clean Spaces, Happy Faces", "Deep Clean Specialist", "Immaculate Living", "Reliable & Trustworthy", "Making Homes Sparkle"];

export const EditorialMarquee = () => (
  <section className="bg-espresso py-8 md:py-10 overflow-hidden" data-testid="marquee">
    <Marquee speed={38} gradient={false} autoFill>
      {items.map((t, i) => (
        <span key={i} className="mx-8 md:mx-14 inline-flex items-center gap-8 md:gap-14">
          <span className="font-serif italic font-light text-3xl md:text-5xl text-cream/85">{t}</span>
          <span className="text-blush text-2xl">✦</span>
        </span>
      ))}
    </Marquee>
  </section>
);
